import React, { createContext, useContext, useEffect } from 'react';
import { applyCustomTheme } from '../helpers/customTheme';
import { usePersistedState } from '../helpers/useDashboardStorage';

const ThemeModeContext = createContext(null);

export function ThemeModeProvider({ children }) {
  const [darkMode, setDarkMode] = usePersistedState('app_dark_mode', false);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', darkMode);
    applyCustomTheme();
  }, [darkMode]);

  const value = {
    darkMode,
    setDarkMode,
    toggleDarkMode: () => setDarkMode((current) => !current),
  };

  return (
    <ThemeModeContext.Provider value={value}>
      {children}
    </ThemeModeContext.Provider>
  );
}

export function useThemeMode() {
  const context = useContext(ThemeModeContext);
  if (!context) throw new Error('useThemeMode must be used within ThemeModeProvider');
  return context;
}

export default ThemeModeContext;
